import React from "react";

export default function Navbar() {
  return (
    <>
      <div className="flex h-20 bg-white p-6 fixed top-0 w-full z-10">
        <button className="ml-auto flex">
          <span className="text-basic-orange">Area Malang</span>
          <img className="h-4 ml-auto mt-1" src="/assets/icon/chevron-down-outline.svg" alt="" />
        </button>
      </div>
    </>
  );
}
